import * as React from "react";
import { Navigate } from "react-router-dom";

export default function PublicRoute({ children }: { children: React.ReactElement }) {
  const isAuthenticated = localStorage.getItem("access_token") !== null;

  if (isAuthenticated) {
    return <Navigate to="/home" replace />;
  }

  return children;
}
